export default __webpack_public_path__ + "static/expert-2-b53e8c44cd04f06f53b6d6c2b3cb0db7.png";